import { render, staticRenderFns } from "./BioLockupModule.vue?vue&type=template&id=6b08f890&"
import script from "./BioLockupModule.ts?vue&type=script&lang=ts&"
export * from "./BioLockupModule.ts?vue&type=script&lang=ts&"
import style0 from "./BioLockupModule.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports